import Action from 'redux/helpers/createAction'
const name = 'users'

export const toogleModal = Action(name + '/TOGGLE_MODAL')

export const getUsers = Action(name + '/GET_USERS')

export const getUsersSuccess = Action(name + '/GET_USERS_SUCCESS', users => ({
  users
}))

export const getUsersFailure = Action(name + '/GET_USERS_FAILURE', error => ({
  error
}))

export const deleteUser = Action(name + '/DELETE_USERS', id => ({
  id
}))

export const deleteUserSuccess = Action(name + '/DELETE_USERS_SUCCESS')

export const deleteUserFailure = Action(name + '/DELETE_USERS_FAILURE', error => ({
  error
}))

export const addUser = Action(name + '/ADD_USERS', payload => ({
  payload
}))

export const addUserSuccess = Action(name + '/ADD_USERS_SUCCESS')

export const addUserFailure = Action(name + '/ADD_USERS_FAILURE', errors => ({
  errors
}))

export const editUser = Action(name + '/EDIT_USERS', (id, payload) => ({
  id,
  payload
}))

export const editUserSuccess = Action(name + '/EDIT_USERS_SUCCESS')

export const editUserFailure = Action(name + '/EDIT_USERS_FAILURE', errors => ({
  errors
}))
export const domainAccess = Action(name + '/DOMAIN_ACCESS', (id, payload) => ({
  id,
  payload
}))

export const domainAccessSuccess = Action(name + '/DOMAIN_ACCESS_SUCCESS')

export const domainAccessFailure = Action(name + '/DOMAIN_ACCESS_FAILURE', errors => ({
  errors
}))
